import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CurrentMember,
  TenantMemberListQuery,
  TenantMemberListResponse,
} from './types/member';

const request = createAppRequest();
const AUTH_PREFIX = process.env.UMI_APP_AUTH_BFF_URL || '';

export async function getTenantMembers(
  params?: TenantMemberListQuery,
  options?: ApiRequestOptions,
) {
  return request<TenantMemberListResponse | CurrentMember[]>(
    `${AUTH_PREFIX}/bff/iam-ui/members`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}
